'use client'

import { useModalStore } from "@/context/modalStore";
import { useStateStore } from "@/context/stateStore";
import { IUser } from "@/models/types/user";
import { Session } from "next-auth";
import Link from "next/link";
import { toast } from "sonner";
import { SignOutHook } from "../hooks/sign-out";

export default function DashButtons({ session }: { session: Session | null }) {

    const user = session?.user as IUser | undefined;
    const email = user?.email || '';
    const setSigninModal = useModalStore((state) => state.setOpenSignInModal);
    const setRegisterModal = useModalStore((state) => state.setOpenRegisterModal);
    const setGlobalLoading = useStateStore(state => state.setGlobalLoading);

    

    const signedInOptions = [
        { label: 'See Plants', onClick: () => { setGlobalLoading(true); toast.info('Opening all plants') }, href: '/plants' },
        { label: 'Plant Info', onClick: () => { setGlobalLoading(true); toast.info('Opening plant info') }, href: '/catalog' },
        { label: 'Growing', onClick: () => { setGlobalLoading(true); toast.info('Opening growing list') }, href: '/growing' },
        { label: 'Notes', onClick: () => { setGlobalLoading(true); toast.info('Opening all notes') }, href: '/notes' },
        { label: 'Stats', onClick: () => toast.info('Stats coming soon'), href: '' },
        { label: 'Settings', onClick: () => toast.info('Settings coming soon'), href: '/settings' },
        { label: 'Sign Out', onClick: () => SignOutHook().confirmSignOut(), href: '' },
    ] as { label: string, onClick: (() => void) | null, href: string }[];

    const guestOptions = [
        { label: 'See Plants', onClick: () => { setGlobalLoading(true); toast.info('Opening all plants') }, href: '/plants' },
        { label: 'Plant Info', onClick: () => { setGlobalLoading(true); toast.info('Opening plant info') }, href: '/catalog' },
        { label: 'Growing', onClick: () => { setGlobalLoading(true); toast.info('Opening growing list') }, href: '/growing' },
        { label: 'Notes', onClick: () => { setGlobalLoading(true); toast.info('Opening all notes') }, href: '/notes' },
        { label: 'Stats', onClick: () => toast.info('Stats coming soon'), href: '' },
        { label: 'Sign In', onClick: () => setSigninModal(true), href: '' },
        { label: 'Register', onClick: () => setRegisterModal(true), href: '' }
    ] as { label: string, onClick: (() => void) | null, href: string }[];

    return (
        <div className="flex flex-col justify-center items-center h-full w-full space-y-3 px-4">
            {email && email !== '' ? (
                signedInOptions.map((option, index) => (
                    option.href && option.href !== '' ? (
                        <Link key={index} href={option.href} className="bg-white shadow-md rounded-lg p-6 flex items-center justify-center hover:shadow-xl transition-shadow cursor-pointer w-full">
                            <button
                                type="button"
                                onClick={option.onClick ? option.onClick : () => toast.info('Option coming soon')}
                                className="w-full bg-transparent border-none text-lg hover:underline text-gray-700 text-center cursor-pointer"
                            >
                                <p className="text-center w-full font-semibold text-md sm:text-lg hover:underline text-gray-700 cursor-pointer">
                                    {option.label}
                                </p>
                            </button>
                        </Link>
                    ) : (
                        <button
                            key={index}
                            type="button"
                            onClick={option.onClick ? option.onClick : () => toast.info('Option coming soon')}
                            className="bg-white shadow-md rounded-lg p-6 flex items-center justify-center hover:shadow-xl transition-shadow cursor-pointer w-full hover:underline"
                        >
                            <p className="text-center w-full font-semibold text-md sm:text-lg hover:underline text-gray-700 cursor-pointer">
                                {option.label}
                            </p>
                        </button>
                    )))
            ) : (
                guestOptions.map((option, index) => (
                    option.href && option.href !== '' ? (
                        <Link key={index} href={option.href} className="bg-white shadow-md rounded-lg p-6 flex items-center justify-center hover:shadow-xl transition-shadow cursor-pointer w-full">
                            <button
                                type="button"
                                onClick={option.onClick ? option.onClick : () => toast.info('Option coming soon')}
                                className="w-full bg-transparent border-none text-lg hover:underline text-gray-700 text-center cursor-pointer font-semibold"
                            >
                                <p className="text-center w-full font-semibold text-lg hover:underline text-gray-700 cursor-pointer">
                                    {option.label}
                                </p>
                            </button>
                        </Link>
                    ) : (
                        <button
                            key={index}
                            type="button"
                            onClick={option.onClick ? option.onClick : () => toast.info('Option coming soon')}
                            className="bg-white shadow-md rounded-lg p-6 flex items-center justify-center hover:shadow-xl transition-shadow cursor-pointer w-full hover:underline"
                        >
                            <p className="text-center w-full font-semibold text-lg hover:underline text-gray-700 cursor-pointer">
                                {option.label}
                            </p>
                        </button>
                    )
                ))
            )}
        </div>
    )
}
